import React from 'react';
import ResourceWorkspace from '../../components/admin/ResourceWorkspace';
import OperationsPanel from '../../components/admin/OperationsPanel';

const tabs = [
  {
    "title": "All requests",
    "resource": "admin_rest/withdrawalrequest",
    "columns": [
      "id",
      "created",
      "user",
      "currency",
      "blockchain",
      "amount",
      "state",
      "approved",
      "confirmed",
      "is_freezed"
    ]
  },
  {
    "title": "BTC queue",
    "resource": "cryptocoins/btcwithdrawalapprove"
  },
  {
    "title": "ETH queue",
    "resource": "cryptocoins/ethwithdrawalapprove"
  },
  {
    "title": "TRX queue",
    "resource": "cryptocoins/trxwithdrawalapprove"
  },
  {
    "title": "BNB queue",
    "resource": "cryptocoins/bnbwithdrawalapprove"
  },
  {
    "title": "MATIC queue",
    "resource": "cryptocoins/maticwithdrawalapprove"
  },
  {
    "title": "Withdrawal limits",
    "resource": "core/withdrawallimitlevel"
  },
  {
    "title": "User limits",
    "resource": "core/withdrawaluserlimit"
  },
  {
    "title": "Fees",
    "resource": "core/withdrawalfee"
  }
];

export default function WithdrawalsPage() {
  return <ResourceWorkspace title="Withdrawal operations"  tabs={tabs}><OperationsPanel group="withdrawals" /></ResourceWorkspace>;
}
